export enum ReturnInterval {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
}

export enum PinnedItemsReturnIntervals {
  WEEKLY = ReturnInterval.WEEKLY,
  MONTHLY = ReturnInterval.MONTHLY,
}
